import type { ComponentProps } from 'react';
import type { AppSection } from '@financial/shared';
import { PageHeader } from '../ui/Primitives';
import { SectionGuide } from './SectionGuide';

type GuidedPageHeaderProps = ComponentProps<typeof PageHeader> & {
  section: AppSection;
};

/** Mantiene el título de la pantalla antes de la ayuda contextual. */
export function GuidedPageHeader({ section, ...headerProps }: GuidedPageHeaderProps) {
  return (
    <>
      <PageHeader {...headerProps} />
      <SectionGuide section={section} />
    </>
  );
}
